
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bimi-visualizer",
      function () {
        return require("private-next-pages/bimi-visualizer.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bimi-visualizer"])
      });
    }
  